import { Component, inject } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { RestApiService } from "../core/services/rest-api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { Location } from "@angular/common";
import { ToastService } from "../core/services/toast.service";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../core/services/auth.service";
import { Collection } from "../core/const/collections";
import { ResponsiveService } from "../core/services/responsive.service";
import { LectureSeuleService } from "../core/services/lecture-seule.service";

@Component({
	template: "",
})
export class BaseComponent {
	protected logger = inject(NGXLogger);
	protected restApiService = inject(RestApiService);
	protected authService = inject(AuthenticationService);
	protected toast = inject(ToastService);
	protected route = inject(ActivatedRoute);
	protected responsiveService = inject(ResponsiveService);
	protected router = inject(Router);
	protected fb = inject(FormBuilder);
	protected location = inject(Location);
	protected dialog = inject(MatDialog);
	protected modalService = inject(NgbModal);
	protected lectureSeuleService = inject(LectureSeuleService);
	protected isSubmitted = false;
	protected isDataDetailLoading = false;
	protected backendURL = environment.backendURL;

	// functions
	public gobBack() {
		this.location.back();
	}
	protected copyToClipboard(event, text: string, message: string) {
		event.preventDefault();
		event.stopPropagation();
		navigator.clipboard
			.writeText(text)
			.then(() => {
				this.toast.info(message);
			})
			.catch((err) => {});
	}
	protected closeMdl(content: any) {
		this.modalService.dismissAll(content);
	}

	public openMdl(content: any) {
		this.modalService.open(content, { size: "lg", centered: true, backdrop: "static" });
	}
	public get isAdmin() {
		return this.authService.isAdmin();
	}
	/** Écran ouvert en consultation seule au rôle courant : aucune action d'écriture. */
	public get isLectureSeule() {
		return this.lectureSeuleService.isLectureSeule;
	}
	get Collection() {
		return Collection;
	}
}
